<template>
  <div :class="['base-button', primaryColor]" @click="onClick">
    <slot></slot>
    <icon-arrow v-if="showIcon" class="icon-arrow" />
  </div>
</template>

<script>
import iconArrow from "@/assets/img/common/arrow.svg?inline";

export default {
  name: "BaseButton",
  props: {
    primary: {
      type: [String],
      default: "light"
    },
    icon: {
      type: [Boolean],
      default: false
    }
  },
  computed: {
    primaryColor() {
      return this.primary;
    },
    showIcon() {
      return this.icon;
    }
  },
  components: {
    iconArrow
  },
  methods: {
    onClick() {
      this.$emit("click");
    }
  }
};
</script>

<style scoped lang="scss">
.base-button {
  min-width: 13.75rem;
  height: 3.75rem;
  width: 13.75rem;
  border-radius: 1.875rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.375rem;
  font-weight: 600;
  color: white;
  cursor: pointer;

  svg {
    margin-left: 0.5625rem;
  }
}

.icon-arrow {
  color: #fff;
}

.light {
  background: rgba(255, 255, 255, 0.3);
  transition: 0.2s ease-in-out;
  &:hover,
  &:focus {
    box-shadow: inset 0 0 0 2.25rem colors(dark);
  }
}

.dark {
  background: colors(dark);
  transition: 0.2s ease-in-out;
  &:hover,
  &:focus {
    box-shadow: inset 0 0 0 2.25rem rgba(255, 255, 255, 0.3);
  }
}

.white {
  color: colors(dark);
  background: white;
  transition: 0.2s ease-in-out;
  &:hover,
  &:focus {
    color: white;
    box-shadow: inset 0 0 0 2.25rem colors(dark);
  }
}

.gold {
  background: colors(theme);
  transition: 0.2s ease-in-out;
  &:hover,
  &:focus {
    box-shadow: inset 0 0 0 2.25rem rgba(255, 255, 255, 0.3);
  }
}
</style>
